const enc = new TextEncoder();
const hex = (buf) => [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, "0")).join("");

export async function verifyRound(seed, roundNo, cap) {
  const sha = hex(await crypto.subtle.digest("SHA-256", enc.encode(seed)));
  const key = await crypto.subtle.importKey("raw", enc.encode(seed), { name: "HMAC", hash: "SHA-256" }, false, ["sign"]);
  const h = hex(await crypto.subtle.sign("HMAC", key, enc.encode(String(roundNo))));
  let crash;
  if (BigInt("0x" + h) % 33n === 0n) crash = 1;
  else {
    const hv = Number.parseInt(h.slice(0, 13), 16);
    const e = 2 ** 52;
    crash = Math.floor((100 * e - hv) / (e - hv)) / 100;
  }
  crash = Math.max(1, Math.min(crash, cap));
  return { sha, crash };
}

export const fmtPKT = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  const opt = { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" };
  const pkt = d.toLocaleString("en-GB", { ...opt, timeZone: "Asia/Karachi" });
  const local = d.toLocaleString("en-GB", opt);
  return pkt === local ? `${pkt} (PKT)` : `${pkt} (PKT) · ${local} (your time)`;
};
